var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-5"},[_c('h1',{staticClass:"pt-5"},[_vm._v("Latest Cars")]),_c('CarList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }